import React from 'react'
import { FormattedMessage } from 'react-intl'

export const TOOLTIP_BODY = (
    <FormattedMessage
        id='card_image.tooltip_body'
        defaultMessage='Нажмите, чтобы узнать условия модернизации строения в зависимости от его уровня.'
    />
)

export const MODERNIZATION_BUTTON_TITLE = (
    <FormattedMessage
        id='modernization_button.title'
        defaultMessage='О модернизации'
    />
)

export const UPGRADE_EFFECT_TOOLTIP_ID = 'upgrade_effect_tooltip'



// WEBPACK FOOTER //
// ./components/UpgradeEffect/constants.jsx